import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BedDouble, CalendarCheck2, Coins, Clock, Star, MessageSquare } from "lucide-react";
import StaffLayout from "@/components/staff/StaffLayout";
import { api, fmtMoney } from "@/lib/api";

export default function StaffDashboard() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
    api.get("/admin/bookings").then((r) => setRecent(r.data.slice(0, 8)));
  }, []);
  return (
    <StaffLayout>
      <h1 className="font-display text-4xl">Dashboard</h1>
      <p className="text-sm text-[#71717A] mt-1">Today's overview of Berdhill Rooms.</p>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        <Stat icon={<BedDouble />} label="Rooms" value={stats?.total_rooms ?? "—"} />
        <Stat icon={<CalendarCheck2 />} label="Bookings" value={stats?.total_bookings ?? "—"} />
        <Stat icon={<Clock />} label="Pending" value={stats?.pending_bookings ?? "—"} />
        <Stat icon={<Coins />} label="Revenue" value={stats ? fmtMoney(stats.revenue) : "—"} />
        <Stat icon={<Star />} label="Reviews to moderate" value={stats?.pending_reviews ?? "—"} link="/staff/reviews" />
        <Stat icon={<MessageSquare />} label="New messages" value={stats?.new_messages ?? "—"} link="/staff/messages" />
      </div>

      <div className="mt-10 bg-white border border-[#E4E4E7] rounded-md">
        <div className="p-5 border-b border-[#E4E4E7]"><h2 className="font-display text-2xl">Recent bookings</h2></div>
        <div className="divide-y divide-[#F4F4F5]">
          {recent.length === 0 ? (
            <div className="p-8 text-center text-sm text-[#71717A]">No bookings yet.</div>
          ) : recent.map((b) => (
            <div key={b.id} className="p-5 flex items-center gap-4 text-sm">
              <div className="flex-1">
                <div className="font-medium">{b.room_name}</div>
                <div className="text-[#71717A] text-xs">{b.guest_name} · {b.guest_email}</div>
              </div>
              <div className="text-[#71717A]">{b.check_in} → {b.check_out}</div>
              <div className="font-medium">{fmtMoney(b.total)}</div>
              <span className={`text-[10px] uppercase tracking-wide px-2 py-1 rounded-sm ${
                b.status === "confirmed" ? "bg-emerald-100 text-emerald-700" :
                b.status === "pending" ? "bg-amber-100 text-amber-700" :
                "bg-rose-100 text-rose-700"
              }`}>{b.status}</span>
            </div>
          ))}
        </div>
      </div>
    </StaffLayout>
  );
}

function Stat({ icon, label, value, link }) {
  const body = (
    <>
      <div className="text-brand-primary mb-3">{icon}</div>
      <div className="text-xs uppercase tracking-wider text-[#71717A]">{label}</div>
      <div className="font-display text-3xl mt-1">{value}</div>
    </>
  );
  return link ? (
    <Link to={link} className="bg-white border border-[#E4E4E7] rounded-md p-5 hover:border-brand-primary transition-colors">{body}</Link>
  ) : (
    <div className="bg-white border border-[#E4E4E7] rounded-md p-5">{body}</div>
  );
}
